import { Cta } from '__generated__/graphql';
export const whiteToBlack = x =>
  ({
    ...x,
    variant: x.variant === 'white' ? 'black' : x.variant,
  } as Cta);
